import { setComponetsMap } from '@chasi/manager/client/shared'

export async function registerComponents() {
	const component = import.meta.glob('./components/**/*.svelte')
	setComponetsMap(component)
}
